import * as promise from 'es6-promise';
promise.polyfill();
import * as moment from 'moment';

/*import * as FastClick from './vendor/fastclick.js';
 FastClick['attach'](document.body);*/

import Vue from 'vue';
import Simplert from 'vue2-simplert'
import * as _ from 'lodash';
import VeeValidate from 'vee-validate';
import {Validator} from 'vee-validate';

import {store} from './store';
import {router, routes} from './router';
import {NavbarComponent} from './components/navbar/navbar';

import './components/registation-page/registration-page';
import './components/spinner/spinner';
import './components/validation-error/validation-error';
import './components/registration-form-submit/registration-form-submit';
import './components/input-group/input-group';
import './components/clubcard/clubcard';
import './components/tooltip/tooltip';
import './components/checkbox/checkbox';
import './components/radio/radio';
import './directives/placeholder-title/placeholder-title';
import './directives/input-mask/input-mask';
import './custom-validators';
import {UserApiService} from '@/services/generated/edge/user';
import {AddressApiService} from '@/services/generated/edge/info';
import {dictionary} from '@/validation-dictionary';

Validator.installDateTimeValidators(moment);

Vue.use(VeeValidate, {
  events: 'blur',
  enableAutoClasses: true,
  dictionary: {
    en: {
      custom: dictionary
    }
  }
});


if (EDGE_URL !== '{{ edgeUrl }}') {
  UserApiService.servicePath = EDGE_URL;
  AddressApiService.servicePath = 'https://api-int.dev.fsniwaikato.kiwi/v1/edge';
}

Vue.directive('no-auto-complete', {
  // When the bound element is inserted into the DOM...
  inserted: function (el) {
    // Focus the element
    el.setAttribute('autocomplete', 'off');
    el.setAttribute('autocorrect', 'off');
    el.setAttribute('autocapitalize', 'off');
    el.setAttribute('spellcheck', 'false');
  }
});

new Vue({
          el: '#app-main',
          router: router,
          store,
          data: {
            transitionName: 'slide-left'
          },
          components: {
            'navbar': NavbarComponent,
            Simplert
          },
          mounted: function () {
            if (this.$router.currentRoute.path == '/') {
              this.$router.push('email-entry');
            }
          },
          methods: {
            alert(text) {
              (<any>this.$refs.simplert).openSimplert({
                                                        message: text,
                                                        customCloseBtnClass: 'inverted'
                                                      });
            }
            
          },
          watch: {
            '$route' (to, from) {
              if (to.path == '/address-entry') {
                this.$data['transitionName'] = 'slide-address';
              } else if (from.path == '/address-entry') {
                this.$data['transitionName'] = 'slide-address-back';
              } else if (from.path == '/') {
                this.$data['transitionName'] = 'none';
              } else {
                this.$data['transitionName'] = _.findIndex(routes, {path: to.path}) > _.findIndex(routes,
                                                                                                  {path: from.path}) ? 'slide-left' : 'slide-right';
              }

              const el = <HTMLElement>document.getElementsByClassName('page-container')[0];

              if (el) {
                el.style.top = '-' + window.scrollY + 'px';
              }
            }
          }
        });



// WEBPACK FOOTER //
// ./src/main.ts